var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeamRifleVariant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.356 41.9161L116.207 41.4465L115.499 41.7735L93.6771 35.652C93.6771 35.652 93.9906 35.1181 93.3801 34.4281C92.7696 33.7381 92.2446 32.1631 92.2446 32.1631L89.5491 21.2266L89.3916 19.7761L88.4121 18.3481L88.2696 17.4991L86.0301 15.7156L85.8231 14.1016L85.7991 13.1641L87.3096 11.7361L86.6151 11.2051L87.3096 10.2661C87.3096 10.2661 86.8701 9.49055 85.3911 9.63305C83.9121 9.77555 77.9226 12.0616 77.9226 12.0616C77.9226 12.0616 76.7031 12.4636 75.9801 12.3106C75.2571 12.1576 74.9571 12.0616 74.9571 12.0616L74.3586 12.4966L73.5426 12.0616L73.1181 12.7561L72.4551 12.6061L72.0891 13.1641L71.3391 13.1776L70.4691 14.3476L69.5706 14.4241C69.5706 14.4241 68.0481 16.0336 67.6086 16.3276C67.1676 16.6216 66.2916 17.2051 66.2916 17.2051C66.2916 17.2051 64.6116 17.4166 63.7776 17.6236C62.9436 17.8306 63.1626 17.3146 63.1626 17.3146L63.0546 14.9401L63.5991 12.5116L61.6401 12.4711L60.9456 12.7561L60.4326 12.1336L52.0281 14.4301C52.0281 14.4301 50.7396 14.3131 50.0901 14.4301C49.4406 14.5471 46.2951 14.9401 46.2951 14.9401L44.8671 15.7156C44.8671 15.7156 40.7136 16.8571 39.5466 17.3146C38.3781 17.7721 36.6126 19.1971 36.3786 19.4506C36.1446 19.7041 35.1996 20.1166 35.1996 20.1166L23.3016 20.9416C23.3016 20.9416 10.5141 21.8041 9.74006 21.8581C8.96606 21.9121 4.82456 22.1116 4.07156 22.8061C3.31856 23.5006 2.25806 24.4216 2.25806 24.4216L3.98156 24.4501L6.42056 24.6346L5.89856 25.4746L4.82906 25.9816L3.08906 26.7751L4.77956 27.1381L4.10906 27.927L2.82956 28.1446L4.01306 29.0836L5.90456 29.952L6.63806 30.5236L5.95856 30.897L4.21706 32.7106C5.20556 33.0046 11.7726 33.9885 11.7726 33.9885L27.7671 36.072L43.7826 38.4721L50.5551 39.3825C50.5551 39.3825 55.0671 40.6981 56.6181 41.0836C58.1691 41.4691 64.9521 42.5535 66.0531 42.6495C67.1541 42.7455 81.3561 43.434 81.3561 43.434L88.9476 43.9006L102.77 45.753L113.002 47.3836L116.294 45.411L117.41 43.4655L117.361 41.9221L117.356 41.9161ZM72.2646 29.9491L70.5231 29.1211L70.8231 32.0356L67.7481 31.5706L68.8371 33.3256L66.2526 33.714L66.5796 31.7761L63.7776 32.7661L63.1926 29.9491L61.7091 31.0801L60.8391 28.9036L62.1321 28.6725L61.0716 26.6326L63.6426 24.8776L61.9011 23.9791L63.8061 22.3471L64.4586 24.0346L65.6556 21.8581L68.1591 23.9536L68.4306 21.9676L70.7706 23.2471L69.2736 24.4441L71.9406 25.1791L70.7166 27.9541L72.7296 27.6541L72.2676 29.952L72.2646 29.9491ZM85.5636 32.631L78.1566 31.1821L77.0541 29.8276L75.7611 24.3601L76.1316 23.2846L76.0956 22.3186L76.3326 21.3121L80.0226 18.2236L82.1691 21.0256L83.0871 22.2766V23.2846L83.7741 23.9881L84.3741 24.8641L85.0161 25.4716L84.8406 26.2651L85.2171 27.135L85.8261 32.0356L85.5651 32.631H85.5636Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2773 23.019C28.2773 23.019 30.4313 20.442 32.3963 20.331",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7095 22.5915C49.7095 22.5915 50.416 21.5295 51.6685 20.985C52.9195 20.4405 54.0085 19.4055 54.0085 19.4055",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0374 24.015C18.0374 24.015 18.3914 25.512 19.3439 25.7835C20.2964 26.055 21.3569 26.301 21.3569 26.9535H23.2889C23.2889 26.9535 23.4269 26.364 22.7519 25.689C22.0769 25.014 20.4734 24.879 20.3504 24.5865C20.1374 24.081 20.1329 23.988 20.1329 23.988L18.0374 24.015V24.015Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 24.015C23.3 24.015 23.654 25.512 24.6065 25.7835C25.559 26.055 26.6195 26.301 26.6195 26.9535H28.5515C28.5515 26.9535 28.6895 26.364 28.0145 25.689C27.3395 25.014 25.736 24.879 25.613 24.5865C25.4 24.081 25.3955 23.988 25.3955 23.988L23.3 24.015Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5627 24.015C28.5627 24.015 28.9167 25.512 29.8692 25.7835C30.8217 26.055 31.8822 26.301 31.8822 26.9535H33.8142C33.8142 26.9535 33.9522 26.364 33.2772 25.689C32.6307 25.0425 30.9987 24.879 30.8757 24.5865C30.6627 24.081 30.6582 23.988 30.6582 23.988L28.5627 24.015Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8254 24.015C33.8254 24.015 34.1794 25.512 35.1319 25.7835C36.0844 26.055 37.1449 26.301 37.1449 26.9535H39.0769C39.0769 26.9535 39.2149 26.364 38.5399 25.689C37.8934 25.0425 36.2614 24.879 36.1384 24.5865C35.9254 24.081 35.9209 23.988 35.9209 23.988L33.8254 24.015V24.015Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0894 24.015C39.0894 24.015 39.4434 25.512 40.3959 25.7835C41.3484 26.055 42.4089 26.301 42.4089 26.9535H44.3409C44.3409 26.9535 44.4789 26.364 43.8039 25.689C43.1574 25.0425 41.5254 24.879 41.4024 24.5865C41.1894 24.081 41.1849 23.988 41.1849 23.988L39.0894 24.015Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0374 30.8625C18.0374 30.8625 18.3914 29.3655 19.3439 29.094C20.2964 28.8225 21.3569 28.5765 21.3569 27.924H23.2889C23.2889 27.924 23.4269 28.5135 22.7519 29.1885C22.0769 29.8635 20.4734 29.9985 20.3504 30.291C20.1374 30.7965 20.1329 30.8895 20.1329 30.8895L18.0374 30.8625V30.8625Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 30.8625C23.3 30.8625 23.654 29.3655 24.6065 29.094C25.559 28.8225 26.6195 28.5765 26.6195 27.924H28.5515C28.5515 27.924 28.6895 28.5135 28.0145 29.1885C27.3395 29.8635 25.736 29.9985 25.613 30.291C25.4 30.7965 25.3955 30.8895 25.3955 30.8895L23.3 30.8625Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5627 30.8625C28.5627 30.8625 28.9167 29.3655 29.8692 29.094C30.8217 28.8225 31.8822 28.5765 31.8822 27.924H33.8142C33.8142 27.924 33.9522 28.5135 33.2772 29.1885C32.6307 29.835 30.9987 29.9985 30.8757 30.291C30.6627 30.7965 30.6582 30.8895 30.6582 30.8895L28.5627 30.8625Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8254 30.8625C33.8254 30.8625 34.1794 29.3655 35.1319 29.094C36.0844 28.8225 37.1449 28.5765 37.1449 27.924H39.0769C39.0769 27.924 39.2149 28.5135 38.5399 29.1885C37.8934 29.835 36.2614 29.9985 36.1384 30.291C35.9254 30.7965 35.9209 30.8895 35.9209 30.8895L33.8254 30.8625V30.8625Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0894 30.8625C39.0894 30.8625 39.4434 29.3655 40.3959 29.094C41.3484 28.8225 42.4089 28.5765 42.4089 27.924H44.3409C44.3409 27.924 44.4789 28.5135 43.8039 29.1885C43.1574 29.835 41.5254 29.9985 41.4024 30.291C41.1894 30.7965 41.1849 30.8895 41.1849 30.8895L39.0894 30.8625Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.353 24.015C44.353 24.015 44.707 25.512 45.6595 25.7835C46.612 26.055 47.6725 26.301 47.6725 26.9535H49.6045C49.6045 26.9535 49.7425 26.364 49.0675 25.689C48.421 25.0425 46.789 24.879 46.666 24.5865C46.453 24.081 46.4485 23.988 46.4485 23.988L44.353 24.015Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.353 30.8625C44.353 30.8625 44.707 29.3655 45.6595 29.094C46.612 28.8225 47.6725 28.5765 47.6725 27.924H49.6045C49.6045 27.924 49.7425 28.5135 49.0675 29.1885C48.421 29.835 46.789 29.9985 46.666 30.291C46.453 30.7965 46.4485 30.8895 46.4485 30.8895L44.353 30.8625Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0891 24.6315V30.8355H50.8511L51.7226 28.713L50.9066 24.6315H50.0891Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8586 25.992C51.8586 25.992 53.7351 25.284 54.6336 24.495C55.5321 23.706 55.9131 23.019 55.9131 23.019L56.0226 22.5915H57.3561L58.3896 24.6315C58.3896 24.6315 56.6211 25.0395 55.8591 25.7745C55.0971 26.5095 55.0161 27.135 55.0161 27.135H52.8771C52.8771 27.135 52.8666 26.754 52.5936 26.6175C52.3206 26.481 51.8586 25.992 51.8586 25.992V25.992Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8586 28.278C51.8586 28.278 53.7351 28.9859 54.6336 29.7749C55.5321 30.5639 55.9131 31.2509 55.9131 31.2509L56.0226 31.6785H57.3561L58.3896 29.6384C58.3896 29.6384 56.6211 29.2304 55.8591 28.4954C55.0971 27.7604 55.0161 27.1349 55.0161 27.1349H52.8771C52.8771 27.1349 52.8666 27.516 52.5936 27.6525C52.3206 27.789 51.8586 28.278 51.8586 28.278V28.278Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1228 37.746C55.7483 36.3855 54.9863 35.814 54.2513 35.1615C53.5163 34.509 52.7003 32.9205 52.7003 32.9205H50.5508C50.5508 32.9205 51.0953 34.4265 51.7208 34.971",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7014 32.9206H54.7969C54.7969 32.9206 56.1304 34.7701 56.4844 35.3341C56.8384 35.8981 57.1039 36.4801 56.9569 37.0186",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7971 32.9206H57.1281C57.1281 32.9206 58.3896 34.4776 58.7436 34.9696C59.0976 35.4616 59.9121 36.6001 59.9946 37.2691",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2925 34.3065C40.2925 34.3065 41.1925 35.298 42.0085 35.8695C42.8245 36.441 43.831 37.311 43.777 38.1555",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1565 43.2599C78.1565 43.2599 85.4345 40.3049 86.618 40.1414C87.8015 39.9779 89.3525 39.9779 91.556 40.4684C93.7595 40.9589 110.33 45.2444 110.33 45.2444L109.473 46.0919L107.188 45.5699L107.733 44.5724",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9729 38.517C89.1064 38.5485 90.6169 38.5485 92.0464 37.7325C93.4744 36.9165 93.9859 35.7375 93.9859 35.7375",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0266 39.1621C93.0266 39.1621 94.1291 38.5876 94.9856 38.5276C95.2661 38.5081 97.3691 39.0076 100.068 39.6901C105.6 41.0866 113.638 43.2436 113.638 43.2436L114.46 44.7436",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5354 40.3859L100.067 39.6899",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M105.067 42.3854L106.873 41.4479",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0058 18.183C88.0058 18.183 86.9858 19.326 86.7818 20.223C86.5778 21.1215 86.4968 23.406 86.1293 24.06C85.7618 24.714 84.8408 25.2255 84.8408 25.2255",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9697 25.6335C84.9697 25.6335 86.8627 25.4475 87.2707 25.0395C87.6787 24.6315 87.8422 24.264 88.0057 23.448C88.1692 22.632 88.5532 20.877 88.9732 20.4285",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5976 23.2844C89.5976 23.2844 88.6586 25.9784 88.4951 26.5499C88.3316 27.1214 88.0871 28.0604 88.4951 28.0604C88.9031 28.0604 90.4541 25.6349 90.4541 25.6349",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3948 26.958C85.3948 26.958 86.0203 26.694 86.9728 27.7845C87.9253 28.875 88.2103 30.837 88.5778 30.9585C88.9453 31.08 89.1088 30.06 89.5978 29.244C90.0868 28.428 91.1488 27.447 91.1488 27.447",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4798 30.9585C91.4798 30.9585 90.2093 31.8645 89.8838 32.6355C89.5583 33.4065 89.3633 34.4265 89.3633 34.4265",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M91.801 32.6355L91.48 34.6995",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M85.802 28.6725C85.802 28.6725 87.734 29.028 87.935 29.577",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5657 29.8276C85.5657 29.8276 87.6987 30.2611 88.5777 30.9586",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8245 31.1821C85.8245 31.1821 87.6785 31.4671 88.5365 32.1616",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8245 32.2634C85.8245 32.2634 88.271 32.9519 88.5365 33.2834V34.4264L88.577 30.9584",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1694 16.578C82.1694 16.578 84.1824 19.626 84.4554 20.2245C84.7269 20.823 85.3059 21.993 84.8394 22.782C84.3729 23.571 83.7204 23.7615 83.7204 23.7615",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3538 17.3115C81.3538 17.3115 83.6128 20.4405 83.7478 21.093C83.8828 21.7455 83.4628 22.3305 83.2858 22.317",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2317 15.7141C83.2317 15.7141 85.1262 17.9115 86.4237 17.775C87.7212 17.6385 87.9357 17.313 87.9357 17.313",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5591 15.4484C45.5591 15.4484 46.0496 16.4009 46.1711 17.3129L46.2941 18.2249L44.2136 19.8869C44.2136 19.8869 44.2121 20.4704 42.4166 20.9864C40.6211 21.5024 39.0686 22.8044 39.0686 22.8044",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2942 18.2234L57.7632 15.4484L57.3957 14.4284L46.2942 16.7474",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M50.552 19.4054L52.028 16.9995",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5588 18.6315L57.7628 18.0195L58.3883 17.775L58.9463 16.101L61.1093 15.714L61.9658 16.326V17.775",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1094 15.714C61.1094 15.714 61.6809 14.2245 62.1699 13.8165C62.6589 13.4085 62.4984 12.4875 62.4984 12.4875",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1507 12.7546V13.8571L57.3958 14.4286",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7834 13.1625L56.6604 14.4285",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4165 13.7955V15.051",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3343 14.4285L52.0283 15.4485",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1709 17.3115C46.1709 17.3115 43.6164 16.938 43.2204 17.172C42.8244 17.406 42.6609 17.2575 42.4164 17.3115C42.1719 17.3655 42.6819 16.365 42.6819 16.365",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9284 28.155C14.3865 28.155 14.7579 27.7836 14.7579 27.3255C14.7579 26.8674 14.3865 26.496 13.9284 26.496C13.4703 26.496 13.0989 26.8674 13.0989 27.3255C13.0989 27.7836 13.4703 28.155 13.9284 28.155Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9241 37.3935L78.7401 38.6985",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M80.374 39.1065L78.7405 40.1685",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1624 40.1685L77.9244 41.4735",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1622 38.8349L75.5032 39.9224",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M2.01074 24.6316L3.31724 23.4991C3.31724 23.4991 3.56174 22.8361 4.86824 22.5091C4.86824 22.5091 5.76674 22.1416 8.86874 21.9181C11.9707 21.6946 34.0102 20.2246 34.0102 20.2246C34.0102 20.2246 35.8057 20.3056 36.3772 19.4491C36.9487 18.5926 37.3567 18.1846 38.7442 17.6131C40.1317 17.0416 42.2542 16.5241 42.2542 16.5241L45.2737 15.4081C45.2737 15.4081 45.2737 15.1636 46.4977 14.9176C47.7217 14.6731 50.7427 14.4271 50.7427 14.4271H51.7222L60.7012 12.0601L60.9457 12.7546L61.6402 12.4696L63.5992 12.5101V13.2856C63.5992 13.2856 62.9872 14.7556 63.0277 15.2446C63.0682 15.7336 63.1912 17.7751 63.1912 17.7751C63.1912 17.7751 65.3947 17.1631 66.2932 17.2036C67.1917 17.2441 69.8842 17.5711 71.4772 18.3466C73.0687 19.1221 74.8237 20.5096 74.8237 20.5096L74.6197 21.9376L73.1092 21.6931C73.1092 21.6931 70.4152 18.7546 66.1702 18.9991C61.9252 19.2436 59.9932 22.3861 59.9932 22.3861L8.82674 23.4061C8.82674 23.4061 5.52074 23.3251 4.86824 23.7736C4.21574 24.2221 3.76574 24.6301 3.76574 24.6301H2.01074V24.6316Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0088 20.2231C34.0088 20.2231 51.9938 19.6786 54.5513 19.4071C57.1088 19.1356 63.1898 17.7751 63.1898 17.7751",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M66.293 17.2036L67.8845 16.1431L69.8975 14.3476H70.469L71.339 13.1776L71.8835 13.4776L72.455 12.6076L73.0265 12.9076L73.544 12.0646L74.36 12.4996L74.9585 12.0646C74.9585 12.0646 75.911 12.4186 76.727 12.3361C77.543 12.2536 81.7205 10.1461 84.128 9.73808C86.5355 9.33008 87.311 10.2691 87.311 10.2691L86.6165 11.2081L87.311 11.7391L85.8005 13.1671C85.8005 13.1671 86.1275 14.1466 85.964 14.8411L85.8005 15.5356L88.412 17.6176V18.3526L89.3915 19.7806V20.5156C89.3915 20.5156 90.248 24.5161 90.6155 25.3321C90.983 26.1481 92.2895 33.6991 93.023 34.1071C93.758 34.5151 93.6755 35.6581 93.6755 35.6581L115.497 41.7796C115.497 41.7796 116.205 41.6566 116.205 41.4526H117.185C117.185 41.4526 117.783 42.7996 117.402 43.6561C117.021 44.5126 116.286 45.4111 116.286 45.4111L112.994 47.3836L99.335 45.2071L88.9415 43.9006C88.9415 43.9006 78.275 43.1926 74.8205 43.1386C71.366 43.0846 65.597 42.7576 61.079 42.0496C56.5625 41.3416 51.773 39.5461 49.9235 39.3286C48.737 39.1891 39.5375 37.8691 33.092 36.9391C29.486 36.4201 26.741 36.0226 26.741 36.0226L8.45595 33.5401C8.45595 33.5401 5.39445 33.1966 4.21095 32.7121C3.02745 32.2276 2.25195 30.8401 2.25195 30.8401H3.67995C3.67995 30.8401 4.08795 31.4116 5.47545 31.5751C6.86295 31.7386 29.3105 33.3301 29.3105 33.3301C29.3105 33.3301 30.6035 34.2691 31.256 34.5406C31.9085 34.8121 33.182 36.0751 33.0905 36.9406",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3152 33.3256L51.8857 35.3431C51.8857 35.3431 53.0827 36.8221 54.3892 37.6381C55.6957 38.4541 56.9272 39.9421 57.1282 41.2126",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1659 41.4661C58.1659 41.4661 57.2719 39.2671 56.7829 38.5216C56.2939 37.7761 55.8034 36.9991 56.2114 36.9181C56.6194 36.8371 59.7214 37.7746 61.1914 37.8571C62.6614 37.9396 66.4159 38.3476 69.8434 37.5856C73.2724 36.8236 75.4489 35.7361 78.4954 36.1711C81.5419 36.6061 113.268 44.3881 113.268 44.3881L114.302 44.7151C114.302 44.7151 116.505 45.0781 115.145 46.0936",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5782 34.6981C70.3649 34.6981 73.4347 31.6283 73.4347 27.8416C73.4347 24.0548 70.3649 20.9851 66.5782 20.9851C62.7914 20.9851 59.7217 24.0548 59.7217 27.8416C59.7217 31.6283 62.7914 34.6981 66.5782 34.6981Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5786 36.2776C71.2377 36.2776 75.0146 32.5007 75.0146 27.8416C75.0146 23.1825 71.2377 19.4056 66.5786 19.4056C61.9195 19.4056 58.1426 23.1825 58.1426 27.8416C58.1426 32.5007 61.9195 36.2776 66.5786 36.2776Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7617 24.4276C75.7617 24.4276 76.0887 23.8966 76.1292 23.4076C76.1697 22.9171 75.8847 22.1836 76.4142 21.4486C76.9452 20.7136 79.5567 18.6331 79.5567 18.6331H80.4132L83.1072 22.3066V23.5306C83.1072 23.5306 83.9232 23.9791 84.0462 24.4291C84.1692 24.8791 84.8217 25.0816 84.9447 25.3681C85.0677 25.6531 84.7812 26.0626 84.9447 26.5516C85.1082 27.0406 85.1487 26.7151 85.2717 27.4081C85.3947 28.1026 85.8252 32.2651 85.8252 32.2651L85.5882 32.6371L78.0072 30.9991L76.9467 29.6926L75.7632 24.4276H75.7617Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4961 33.8551C72.4961 33.8551 74.7821 31.4476 76.3751 31.8151C77.9666 32.1826 93.6806 35.6521 93.6806 35.6521",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4473 20.2231L75.3533 19.4056V18.3466L76.1693 17.7751L76.7003 18.3466L82.2503 13.9381V13.0411L83.2718 12.3466L83.5163 12.9181L86.6183 11.2036",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5579 18.6316L85.8024 13.1626",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68359 30.8355C3.68359 30.8355 26.9471 31.326 27.6821 31.488C28.4171 31.65 28.9061 32.916 28.9061 32.916",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5565 33.5251L30.499 31.5706H37.927L39.8965 34.2706",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9723 34.4566L40.4573 31.5706H46.5383C46.5383 31.5706 47.1503 32.7136 47.7218 33.3256C48.2933 33.9376 49.2728 34.8766 49.2728 34.8766",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2773 31.8766H30.4988",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2659 32.0356H40.7019",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8057 32.0355C46.8582 32.1225 58.9467 32.0355 58.9467 32.0355",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0686 26.6311L62.1291 28.6726L60.8376 28.9036L61.7076 31.0801L63.1911 29.9491L63.7762 32.7676L66.5781 31.7761L66.2512 33.7141L68.8371 33.3256L67.7481 31.5706L70.8231 32.0356L70.5231 29.1211L72.2647 29.9491L72.7281 27.6526L70.7137 27.9511L71.9391 25.1761L69.2721 24.4411L70.7692 23.2441L68.4291 21.9646L68.1561 23.9521L65.6526 21.8566L64.4557 24.0331L63.8031 22.3456L61.8981 23.9791L63.6397 24.8761L61.0686 26.6311Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76615 24.6317H6.41965V25.3757C6.41965 25.3757 5.15515 25.5302 4.82815 25.9787C4.50115 26.4272 4.82815 25.9787 3.92965 26.2637C3.03115 26.5487 2.82715 27.1622 2.82715 27.1622H5.19415V28.1417H2.82715C2.82715 28.1417 3.07165 28.8767 4.01065 29.0807L4.94965 29.2847C4.94965 29.2847 5.72515 29.9612 6.41965 29.9492C7.11415 29.9372 6.41965 30.8942 6.41965 30.8942",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2562 23.3791C10.2562 23.3791 10.1332 24.6721 9.84671 24.8776C9.84671 24.8776 8.66321 24.7726 8.09171 25.3756C7.52021 25.9786 7.43921 26.9581 7.43921 26.9581C7.43921 26.9581 8.37971 26.3866 8.84771 26.7946L13.6837 25.3756L15.8467 25.6111L17.2342 26.4661L17.1112 24.6316H10.7437L10.2547 23.3791H10.2562Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2562 31.4026C10.2562 31.4026 10.1332 30.1096 9.84671 29.9041C9.84671 29.9041 8.66321 30.0091 8.09171 29.4061C7.52021 28.8031 7.43921 27.8236 7.43921 27.8236C7.43921 27.8236 8.37971 28.3951 8.84771 27.9871L13.6837 29.4061L15.8467 29.1706L17.2342 28.3156L17.1112 30.1501H10.7437L10.2547 31.4026H10.2562Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeamRifleVariant);
export default __webpack_public_path__ + "static/media/Beam Rifle Variant.6ab38d9b26f14fb4f0a10c578b9d6f69.svg";
export { ForwardRef as ReactComponent };